import { LEGEND } from "./timelineUtils";

export function TimelineLegend() {
  return (
    <div className="flex flex-wrap items-center gap-x-5 gap-y-1.5 px-6 py-2 bg-white border-b border-[#E6EFF0]" data-testid="timeline-legend">
      {LEGEND.map((l) => (
        <span key={l.key} className="inline-flex items-center gap-1.5 text-[12px] text-[#3F5257]" data-testid={`legend-${l.key}`}>
          <span className="w-3.5 h-3.5 rounded-[3px] shrink-0" style={l.style} />{l.label}
        </span>
      ))}
    </div>
  );
}

export function TimelineSummary({ summary }) {
  const s = summary || {};
  return (
    <div className="bg-white border-t border-[#D5E6E8] px-6 py-3 flex flex-wrap items-center justify-between gap-2 md:sticky md:bottom-0 rounded-b-lg" data-testid="timeline-summary">
      <div className="text-[13px] font-bold text-[#1A2425]" data-testid="summary-occupancy">Occupancy Today: {s.occupancy_today ?? 0}% ({s.occupied_today ?? 0}/{s.total_rooms ?? 0} rooms)</div>
      <div className="text-[13px] text-[#014751]" data-testid="summary-available">Available Tonight: {s.available_tonight ?? 0} rooms</div>
      <div className="text-[13px] text-[#3F5257]" data-testid="summary-reserved">Reserved (next 7 days): {s.reservations_7_days ?? 0} bookings</div>
    </div>
  );
}
